// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/ryugu/v1/deliverable_import.proto (package mono.ryugu.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * DeliverableImportAction is what the agent determined this proposal should
 * do to program data once committed.
 *
 * @generated from enum mono.ryugu.v1.DeliverableImportAction
 */ export var DeliverableImportAction = /*#__PURE__*/ function(DeliverableImportAction) {
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_ACTION_UNSPECIFIED = 0;
   */ DeliverableImportAction[DeliverableImportAction["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * No existing task matches; committing creates a new one.
   *
   * @generated from enum value: DELIVERABLE_IMPORT_ACTION_CREATE = 1;
   */ DeliverableImportAction[DeliverableImportAction["CREATE"] = 1] = "CREATE";
    /**
   * An existing task matches by key but some fields differ; committing
   * updates it.
   *
   * @generated from enum value: DELIVERABLE_IMPORT_ACTION_UPDATE = 2;
   */ DeliverableImportAction[DeliverableImportAction["UPDATE"] = 2] = "UPDATE";
    /**
   * An existing task matches and every field already agrees; committing is a
   * no-op read-back rather than a write.
   *
   * @generated from enum value: DELIVERABLE_IMPORT_ACTION_ALREADY_MATCHES = 3;
   */ DeliverableImportAction[DeliverableImportAction["ALREADY_MATCHES"] = 3] = "ALREADY_MATCHES";
    /**
   * The agent could not confidently extract or reconcile this row; the
   * Program Lead must resolve it (typically via
   * ReviseDeliverableImportProposal) before it can be approved.
   *
   * @generated from enum value: DELIVERABLE_IMPORT_ACTION_NEEDS_CLARIFICATION = 4;
   */ DeliverableImportAction[DeliverableImportAction["NEEDS_CLARIFICATION"] = 4] = "NEEDS_CLARIFICATION";
    return DeliverableImportAction;
}({});
// Retrieve enum metadata with: proto3.getEnumType(DeliverableImportAction)
proto3.util.setEnumType(DeliverableImportAction, "mono.ryugu.v1.DeliverableImportAction", [
    {
        no: 0,
        name: "DELIVERABLE_IMPORT_ACTION_UNSPECIFIED"
    },
    {
        no: 1,
        name: "DELIVERABLE_IMPORT_ACTION_CREATE"
    },
    {
        no: 2,
        name: "DELIVERABLE_IMPORT_ACTION_UPDATE"
    },
    {
        no: 3,
        name: "DELIVERABLE_IMPORT_ACTION_ALREADY_MATCHES"
    },
    {
        no: 4,
        name: "DELIVERABLE_IMPORT_ACTION_NEEDS_CLARIFICATION"
    }
]);
/**
 * DeliverableImportDecision is the review/commit lifecycle state of one
 * proposal.
 *
 * @generated from enum mono.ryugu.v1.DeliverableImportDecision
 */ export var DeliverableImportDecision = /*#__PURE__*/ function(DeliverableImportDecision) {
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_DECISION_UNSPECIFIED = 0;
   */ DeliverableImportDecision[DeliverableImportDecision["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * Awaiting a Program Lead verdict.
   *
   * @generated from enum value: DELIVERABLE_IMPORT_DECISION_PENDING = 1;
   */ DeliverableImportDecision[DeliverableImportDecision["PENDING"] = 1] = "PENDING";
    /**
   * Approved as proposed, unedited.
   *
   * @generated from enum value: DELIVERABLE_IMPORT_DECISION_APPROVED = 2;
   */ DeliverableImportDecision[DeliverableImportDecision["APPROVED"] = 2] = "APPROVED";
    /**
   * Approved after the Program Lead edited it via
   * ReviseDeliverableImportProposal.
   *
   * @generated from enum value: DELIVERABLE_IMPORT_DECISION_EDITED_APPROVED = 3;
   */ DeliverableImportDecision[DeliverableImportDecision["EDITED_APPROVED"] = 3] = "EDITED_APPROVED";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_DECISION_REJECTED = 4;
   */ DeliverableImportDecision[DeliverableImportDecision["REJECTED"] = 4] = "REJECTED";
    /**
   * Replaced by a newer revision from ReviseDeliverableImportProposal; the
   * newer revision carries its own decision starting at PENDING.
   *
   * @generated from enum value: DELIVERABLE_IMPORT_DECISION_SUPERSEDED = 5;
   */ DeliverableImportDecision[DeliverableImportDecision["SUPERSEDED"] = 5] = "SUPERSEDED";
    /**
   * Written to program tasks and verified by read-back.
   *
   * @generated from enum value: DELIVERABLE_IMPORT_DECISION_COMMITTED = 6;
   */ DeliverableImportDecision[DeliverableImportDecision["COMMITTED"] = 6] = "COMMITTED";
    /**
   * Commit was attempted for this proposal and failed; see the matching
   * DeliverableCommitResult.error for why.
   *
   * @generated from enum value: DELIVERABLE_IMPORT_DECISION_COMMIT_FAILED = 7;
   */ DeliverableImportDecision[DeliverableImportDecision["COMMIT_FAILED"] = 7] = "COMMIT_FAILED";
    return DeliverableImportDecision;
}({});
// Retrieve enum metadata with: proto3.getEnumType(DeliverableImportDecision)
proto3.util.setEnumType(DeliverableImportDecision, "mono.ryugu.v1.DeliverableImportDecision", [
    {
        no: 0,
        name: "DELIVERABLE_IMPORT_DECISION_UNSPECIFIED"
    },
    {
        no: 1,
        name: "DELIVERABLE_IMPORT_DECISION_PENDING"
    },
    {
        no: 2,
        name: "DELIVERABLE_IMPORT_DECISION_APPROVED"
    },
    {
        no: 3,
        name: "DELIVERABLE_IMPORT_DECISION_EDITED_APPROVED"
    },
    {
        no: 4,
        name: "DELIVERABLE_IMPORT_DECISION_REJECTED"
    },
    {
        no: 5,
        name: "DELIVERABLE_IMPORT_DECISION_SUPERSEDED"
    },
    {
        no: 6,
        name: "DELIVERABLE_IMPORT_DECISION_COMMITTED"
    },
    {
        no: 7,
        name: "DELIVERABLE_IMPORT_DECISION_COMMIT_FAILED"
    }
]);
/**
 * DeliverableImportVerdict is the Program Lead's decision on one proposal.
 *
 * @generated from enum mono.ryugu.v1.DeliverableImportVerdict
 */ export var DeliverableImportVerdict = /*#__PURE__*/ function(DeliverableImportVerdict) {
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_VERDICT_UNSPECIFIED = 0;
   */ DeliverableImportVerdict[DeliverableImportVerdict["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_VERDICT_APPROVE = 1;
   */ DeliverableImportVerdict[DeliverableImportVerdict["APPROVE"] = 1] = "APPROVE";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_VERDICT_REJECT = 2;
   */ DeliverableImportVerdict[DeliverableImportVerdict["REJECT"] = 2] = "REJECT";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_VERDICT_DEFER = 3;
   */ DeliverableImportVerdict[DeliverableImportVerdict["DEFER"] = 3] = "DEFER";
    return DeliverableImportVerdict;
}({});
// Retrieve enum metadata with: proto3.getEnumType(DeliverableImportVerdict)
proto3.util.setEnumType(DeliverableImportVerdict, "mono.ryugu.v1.DeliverableImportVerdict", [
    {
        no: 0,
        name: "DELIVERABLE_IMPORT_VERDICT_UNSPECIFIED"
    },
    {
        no: 1,
        name: "DELIVERABLE_IMPORT_VERDICT_APPROVE"
    },
    {
        no: 2,
        name: "DELIVERABLE_IMPORT_VERDICT_REJECT"
    },
    {
        no: 3,
        name: "DELIVERABLE_IMPORT_VERDICT_DEFER"
    }
]);
/**
 * DeliverableCommitStatus is the outcome of committing one proposal.
 *
 * @generated from enum mono.ryugu.v1.DeliverableCommitStatus
 */ export var DeliverableCommitStatus = /*#__PURE__*/ function(DeliverableCommitStatus) {
    /**
   * @generated from enum value: DELIVERABLE_COMMIT_STATUS_UNSPECIFIED = 0;
   */ DeliverableCommitStatus[DeliverableCommitStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: DELIVERABLE_COMMIT_STATUS_CREATED = 1;
   */ DeliverableCommitStatus[DeliverableCommitStatus["CREATED"] = 1] = "CREATED";
    /**
   * @generated from enum value: DELIVERABLE_COMMIT_STATUS_UPDATED = 2;
   */ DeliverableCommitStatus[DeliverableCommitStatus["UPDATED"] = 2] = "UPDATED";
    /**
   * @generated from enum value: DELIVERABLE_COMMIT_STATUS_FAILED = 3;
   */ DeliverableCommitStatus[DeliverableCommitStatus["FAILED"] = 3] = "FAILED";
    return DeliverableCommitStatus;
}({});
// Retrieve enum metadata with: proto3.getEnumType(DeliverableCommitStatus)
proto3.util.setEnumType(DeliverableCommitStatus, "mono.ryugu.v1.DeliverableCommitStatus", [
    {
        no: 0,
        name: "DELIVERABLE_COMMIT_STATUS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "DELIVERABLE_COMMIT_STATUS_CREATED"
    },
    {
        no: 2,
        name: "DELIVERABLE_COMMIT_STATUS_UPDATED"
    },
    {
        no: 3,
        name: "DELIVERABLE_COMMIT_STATUS_FAILED"
    }
]);
/**
 * DeliverableImportCardKind is the kind of chat-tool-result card shanks
 * emits for one step of the import journey.
 *
 * @generated from enum mono.ryugu.v1.DeliverableImportCardKind
 */ export var DeliverableImportCardKind = /*#__PURE__*/ function(DeliverableImportCardKind) {
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_CARD_KIND_UNSPECIFIED = 0;
   */ DeliverableImportCardKind[DeliverableImportCardKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_CARD_KIND_OVERVIEW = 1;
   */ DeliverableImportCardKind[DeliverableImportCardKind["OVERVIEW"] = 1] = "OVERVIEW";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_CARD_KIND_WORKSTREAM_INTRO = 2;
   */ DeliverableImportCardKind[DeliverableImportCardKind["WORKSTREAM_INTRO"] = 2] = "WORKSTREAM_INTRO";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_CARD_KIND_PROPOSAL_REVIEW = 3;
   */ DeliverableImportCardKind[DeliverableImportCardKind["PROPOSAL_REVIEW"] = 3] = "PROPOSAL_REVIEW";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_CARD_KIND_PROPOSAL_REVISED = 4;
   */ DeliverableImportCardKind[DeliverableImportCardKind["PROPOSAL_REVISED"] = 4] = "PROPOSAL_REVISED";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_CARD_KIND_WORKSTREAM_SUMMARY = 5;
   */ DeliverableImportCardKind[DeliverableImportCardKind["WORKSTREAM_SUMMARY"] = 5] = "WORKSTREAM_SUMMARY";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_CARD_KIND_COMMIT_RESULT = 6;
   */ DeliverableImportCardKind[DeliverableImportCardKind["COMMIT_RESULT"] = 6] = "COMMIT_RESULT";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_CARD_KIND_NEXT_WORKSTREAM = 7;
   */ DeliverableImportCardKind[DeliverableImportCardKind["NEXT_WORKSTREAM"] = 7] = "NEXT_WORKSTREAM";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_CARD_KIND_PAUSED_RECAP = 8;
   */ DeliverableImportCardKind[DeliverableImportCardKind["PAUSED_RECAP"] = 8] = "PAUSED_RECAP";
    /**
   * @generated from enum value: DELIVERABLE_IMPORT_CARD_KIND_IMPORT_COMPLETE = 9;
   */ DeliverableImportCardKind[DeliverableImportCardKind["IMPORT_COMPLETE"] = 9] = "IMPORT_COMPLETE";
    return DeliverableImportCardKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(DeliverableImportCardKind)
proto3.util.setEnumType(DeliverableImportCardKind, "mono.ryugu.v1.DeliverableImportCardKind", [
    {
        no: 0,
        name: "DELIVERABLE_IMPORT_CARD_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "DELIVERABLE_IMPORT_CARD_KIND_OVERVIEW"
    },
    {
        no: 2,
        name: "DELIVERABLE_IMPORT_CARD_KIND_WORKSTREAM_INTRO"
    },
    {
        no: 3,
        name: "DELIVERABLE_IMPORT_CARD_KIND_PROPOSAL_REVIEW"
    },
    {
        no: 4,
        name: "DELIVERABLE_IMPORT_CARD_KIND_PROPOSAL_REVISED"
    },
    {
        no: 5,
        name: "DELIVERABLE_IMPORT_CARD_KIND_WORKSTREAM_SUMMARY"
    },
    {
        no: 6,
        name: "DELIVERABLE_IMPORT_CARD_KIND_COMMIT_RESULT"
    },
    {
        no: 7,
        name: "DELIVERABLE_IMPORT_CARD_KIND_NEXT_WORKSTREAM"
    },
    {
        no: 8,
        name: "DELIVERABLE_IMPORT_CARD_KIND_PAUSED_RECAP"
    },
    {
        no: 9,
        name: "DELIVERABLE_IMPORT_CARD_KIND_IMPORT_COMPLETE"
    }
]);
/**
 * DeliverableFields is the full set of fields extracted or edited for one
 * deliverable. It is used both as the staged "proposed" value and, for
 * UPDATE/ALREADY_MATCHES actions, as the "existing" value being compared
 * against — and again, unabridged, as the payload of a revision.
 *
 * @generated from message mono.ryugu.v1.DeliverableFields
 */ export class DeliverableFields extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableFields().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableFields().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableFields().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableFields, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string deliverable_number = 1;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string period_label = 3;
   */ _define_property(this, "periodLabel", ""), /**
   * @generated from field: string period_of_performance_id = 4;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * @generated from field: repeated string pws_sections = 5;
   */ _define_property(this, "pwsSections", []), /**
   * @generated from field: string responsible_person = 6;
   */ _define_property(this, "responsiblePerson", ""), /**
   * @generated from field: string clin_number = 7;
   */ _define_property(this, "clinNumber", ""), /**
   * Canonical cadence token from packages/go-common/cadence
   * (cadence.Cadence): daily, weekly, biweekly, semimonthly, monthly,
   * quarterly, semiannually, annually, one-time, as-needed.
   *
   * @generated from field: string frequency = 8;
   */ _define_property(this, "frequency", ""), /**
   * ISO yyyy-mm-dd.
   *
   * @generated from field: string first_due_date = 9;
   */ _define_property(this, "firstDueDate", ""), /**
   * ISO yyyy-mm-dd.
   *
   * @generated from field: string series_end_date = 10;
   */ _define_property(this, "seriesEndDate", ""), /**
   * ISO yyyy-mm-dd, one per occurrence.
   *
   * @generated from field: repeated string occurrence_dates = 11;
   */ _define_property(this, "occurrenceDates", []), /**
   * @generated from field: string due_date_notes = 12;
   */ _define_property(this, "dueDateNotes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableFields, "runtime", proto3);
_define_property(DeliverableFields, "typeName", "mono.ryugu.v1.DeliverableFields");
_define_property(DeliverableFields, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "responsible_person",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "frequency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "first_due_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "series_end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "occurrence_dates",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 12,
            name: "due_date_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SourceRef pins a proposal back to the workbook cells it was built from.
 *
 * @generated from message mono.ryugu.v1.SourceRef
 */ export class SourceRef extends Message {
    static fromBinary(bytes, options) {
        return new SourceRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SourceRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SourceRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SourceRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string file_name = 1;
   */ _define_property(this, "fileName", ""), /**
   * @generated from field: string source_artifact_id = 2;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * @generated from field: string sheet_name = 3;
   */ _define_property(this, "sheetName", ""), /**
   * 1-based workbook row numbers this proposal was built from.
   *
   * @generated from field: repeated int32 rows = 4;
   */ _define_property(this, "rows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SourceRef, "runtime", proto3);
_define_property(SourceRef, "typeName", "mono.ryugu.v1.SourceRef");
_define_property(SourceRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rows",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        }
    ]));
/**
 * DeliverableImportProposal is one staged deliverable awaiting or having
 * completed review.
 *
 * @generated from message mono.ryugu.v1.DeliverableImportProposal
 */ export class DeliverableImportProposal extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableImportProposal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableImportProposal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableImportProposal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableImportProposal, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * The literal constant "program-level" is used for deliverables that
   * belong to no workstream (e.g. CLIN 0001 base deliverables) — never
   * invent a fictional workstream for these. "program-level" is already an
   * established constant elsewhere in this repo.
   *
   * @generated from field: string workstream_key = 3;
   */ _define_property(this, "workstreamKey", ""), /**
   * @generated from field: string workstream_label = 4;
   */ _define_property(this, "workstreamLabel", ""), /**
   * Review order within the workstream.
   *
   * @generated from field: int32 ordinal = 5;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: mono.ryugu.v1.DeliverableImportAction action = 6;
   */ _define_property(this, "action", 0), /**
   * @generated from field: mono.ryugu.v1.DeliverableImportDecision decision = 7;
   */ _define_property(this, "decision", 0), /**
   * Set when action is UPDATE or ALREADY_MATCHES: the program task this
   * proposal reconciles against.
   *
   * @generated from field: string existing_task_id = 8;
   */ _define_property(this, "existingTaskId", ""), /**
   * @generated from field: mono.ryugu.v1.DeliverableFields proposed = 9;
   */ _define_property(this, "proposed", void 0), /**
   * Set for UPDATE/ALREADY_MATCHES: the current state of the matched task,
   * for the reviewer to diff against `proposed`.
   *
   * @generated from field: mono.ryugu.v1.DeliverableFields existing = 10;
   */ _define_property(this, "existing", void 0), /**
   * Names of fields in `proposed` that differ from `existing`. Empty for
   * CREATE and ALREADY_MATCHES.
   *
   * @generated from field: repeated string changed_fields = 11;
   */ _define_property(this, "changedFields", []), /**
   * @generated from field: mono.ryugu.v1.SourceRef source = 12;
   */ _define_property(this, "source", void 0), /**
   * Set when action is NEEDS_CLARIFICATION: what the agent needs the
   * Program Lead to resolve.
   *
   * @generated from field: string clarification_question = 13;
   */ _define_property(this, "clarificationQuestion", ""), /**
   * Free-text rationale recorded with a REJECT or DEFER verdict.
   *
   * @generated from field: string decision_rationale = 14;
   */ _define_property(this, "decisionRationale", ""), /**
   * Free-text reason recorded with a revision.
   *
   * @generated from field: string revision_reason = 15;
   */ _define_property(this, "revisionReason", ""), /**
   * Set when this proposal is itself a revision: the proposal id it
   * supersedes.
   *
   * @generated from field: string supersedes_proposal_id = 16;
   */ _define_property(this, "supersedesProposalId", ""), /**
   * Number of occurrences this deliverable will schedule once committed
   * (len(occurrence_dates), or the projected count for a recurring series).
   *
   * @generated from field: int32 occurrence_count = 17;
   */ _define_property(this, "occurrenceCount", 0), /**
   * Set once a commit attempt has been made for this proposal.
   *
   * @generated from field: mono.ryugu.v1.DeliverableCommitResult commit_result = 18;
   */ _define_property(this, "commitResult", void 0), /**
   * @generated from field: string decided_by = 19;
   */ _define_property(this, "decidedBy", ""), /**
   * RFC3339 timestamp of the last decision (resolve or revise) on this
   * proposal.
   *
   * @generated from field: string decided_at = 20;
   */ _define_property(this, "decidedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableImportProposal, "runtime", proto3);
_define_property(DeliverableImportProposal, "typeName", "mono.ryugu.v1.DeliverableImportProposal");
_define_property(DeliverableImportProposal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workstream_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "action",
            kind: "enum",
            T: proto3.getEnumType(DeliverableImportAction)
        },
        {
            no: 7,
            name: "decision",
            kind: "enum",
            T: proto3.getEnumType(DeliverableImportDecision)
        },
        {
            no: 8,
            name: "existing_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "proposed",
            kind: "message",
            T: DeliverableFields
        },
        {
            no: 10,
            name: "existing",
            kind: "message",
            T: DeliverableFields
        },
        {
            no: 11,
            name: "changed_fields",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 12,
            name: "source",
            kind: "message",
            T: SourceRef
        },
        {
            no: 13,
            name: "clarification_question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "decision_rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "revision_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "supersedes_proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "occurrence_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 18,
            name: "commit_result",
            kind: "message",
            T: DeliverableCommitResult
        },
        {
            no: 19,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "decided_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * WorkstreamSummary is the per-workstream rollup shown before a Program Lead
 * drills into that workstream's proposals.
 *
 * @generated from message mono.ryugu.v1.WorkstreamSummary
 */ export class WorkstreamSummary extends Message {
    static fromBinary(bytes, options) {
        return new WorkstreamSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkstreamSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkstreamSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkstreamSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: int32 workbook_row_count = 3;
   */ _define_property(this, "workbookRowCount", 0), /**
   * @generated from field: int32 proposed_creates = 4;
   */ _define_property(this, "proposedCreates", 0), /**
   * @generated from field: int32 proposed_updates = 5;
   */ _define_property(this, "proposedUpdates", 0), /**
   * @generated from field: int32 already_matches = 6;
   */ _define_property(this, "alreadyMatches", 0), /**
   * @generated from field: int32 needs_clarification = 7;
   */ _define_property(this, "needsClarification", 0), /**
   * @generated from field: int32 approved = 8;
   */ _define_property(this, "approved", 0), /**
   * @generated from field: int32 edited_approved = 9;
   */ _define_property(this, "editedApproved", 0), /**
   * @generated from field: int32 rejected = 10;
   */ _define_property(this, "rejected", 0), /**
   * @generated from field: int32 pending = 11;
   */ _define_property(this, "pending", 0), /**
   * @generated from field: int32 committed = 12;
   */ _define_property(this, "committed", 0), /**
   * @generated from field: int32 commit_failed = 13;
   */ _define_property(this, "commitFailed", 0), /**
   * Count of proposals with a terminal-for-review decision (approved,
   * edited_approved, rejected — i.e. not pending).
   *
   * @generated from field: int32 reviewed = 14;
   */ _define_property(this, "reviewed", 0), /**
   * Total proposals in this workstream that require a Program Lead verdict
   * (excludes SUPERSEDED).
   *
   * @generated from field: int32 total_to_review = 15;
   */ _define_property(this, "totalToReview", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WorkstreamSummary, "runtime", proto3);
_define_property(WorkstreamSummary, "typeName", "mono.ryugu.v1.WorkstreamSummary");
_define_property(WorkstreamSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workbook_row_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "proposed_creates",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "proposed_updates",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "already_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "needs_clarification",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "approved",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "edited_approved",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "rejected",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "pending",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "committed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "commit_failed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "reviewed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "total_to_review",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * DeliverableImportTotals summarizes what the agent found in the workbook,
 * shown once at the top of the review regardless of workstream.
 *
 * @generated from message mono.ryugu.v1.DeliverableImportTotals
 */ export class DeliverableImportTotals extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableImportTotals().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableImportTotals().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableImportTotals().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableImportTotals, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 workbook_rows = 1;
   */ _define_property(this, "workbookRows", 0), /**
   * @generated from field: int32 header_rows = 2;
   */ _define_property(this, "headerRows", 0), /**
   * @generated from field: int32 deliverable_records = 3;
   */ _define_property(this, "deliverableRecords", 0), /**
   * @generated from field: int32 scheduled_occurrences = 4;
   */ _define_property(this, "scheduledOccurrences", 0), /**
   * @generated from field: int32 unresolved_rows = 5;
   */ _define_property(this, "unresolvedRows", 0), /**
   * @generated from field: int32 recurring_records = 6;
   */ _define_property(this, "recurringRecords", 0), /**
   * @generated from field: int32 one_time_records = 7;
   */ _define_property(this, "oneTimeRecords", 0), /**
   * @generated from field: int32 as_needed_records = 8;
   */ _define_property(this, "asNeededRecords", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableImportTotals, "runtime", proto3);
_define_property(DeliverableImportTotals, "typeName", "mono.ryugu.v1.DeliverableImportTotals");
_define_property(DeliverableImportTotals, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workbook_rows",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "header_rows",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "deliverable_records",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "scheduled_occurrences",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "unresolved_rows",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "recurring_records",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "one_time_records",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "as_needed_records",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * DeliverableImportProposalInput is one row the agent staged, as submitted to
 * StageDeliverableImport.
 *
 * @generated from message mono.ryugu.v1.DeliverableImportProposalInput
 */ export class DeliverableImportProposalInput extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableImportProposalInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableImportProposalInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableImportProposalInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableImportProposalInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string workstream_key = 1;
   */ _define_property(this, "workstreamKey", ""), /**
   * @generated from field: string workstream_label = 2;
   */ _define_property(this, "workstreamLabel", ""), /**
   * @generated from field: int32 ordinal = 3;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: mono.ryugu.v1.DeliverableImportAction action = 4;
   */ _define_property(this, "action", 0), /**
   * Set when action is UPDATE or ALREADY_MATCHES.
   *
   * @generated from field: string existing_task_id = 5;
   */ _define_property(this, "existingTaskId", ""), /**
   * @generated from field: mono.ryugu.v1.DeliverableFields proposed = 6;
   */ _define_property(this, "proposed", void 0), /**
   * @generated from field: mono.ryugu.v1.SourceRef source = 7;
   */ _define_property(this, "source", void 0), /**
   * Set when action is NEEDS_CLARIFICATION.
   *
   * @generated from field: string clarification_question = 8;
   */ _define_property(this, "clarificationQuestion", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableImportProposalInput, "runtime", proto3);
_define_property(DeliverableImportProposalInput, "typeName", "mono.ryugu.v1.DeliverableImportProposalInput");
_define_property(DeliverableImportProposalInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "action",
            kind: "enum",
            T: proto3.getEnumType(DeliverableImportAction)
        },
        {
            no: 5,
            name: "existing_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "proposed",
            kind: "message",
            T: DeliverableFields
        },
        {
            no: 7,
            name: "source",
            kind: "message",
            T: SourceRef
        },
        {
            no: 8,
            name: "clarification_question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * StageDeliverableImportRequest creates a new import ledger (change_set_id
 * empty) or appends proposals to an existing one (change_set_id set).
 *
 * @generated from message mono.ryugu.v1.StageDeliverableImportRequest
 */ export class StageDeliverableImportRequest extends Message {
    static fromBinary(bytes, options) {
        return new StageDeliverableImportRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StageDeliverableImportRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StageDeliverableImportRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StageDeliverableImportRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string file_name = 3;
   */ _define_property(this, "fileName", ""), /**
   * @generated from field: string source_artifact_id = 4;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * @generated from field: string sheet_name = 5;
   */ _define_property(this, "sheetName", ""), /**
   * @generated from field: mono.ryugu.v1.DeliverableImportTotals totals = 6;
   */ _define_property(this, "totals", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.DeliverableImportProposalInput proposals = 7;
   */ _define_property(this, "proposals", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StageDeliverableImportRequest, "runtime", proto3);
_define_property(StageDeliverableImportRequest, "typeName", "mono.ryugu.v1.StageDeliverableImportRequest");
_define_property(StageDeliverableImportRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "totals",
            kind: "message",
            T: DeliverableImportTotals
        },
        {
            no: 7,
            name: "proposals",
            kind: "message",
            T: DeliverableImportProposalInput,
            repeated: true
        }
    ]));
/**
 * StageDeliverableImportResponse returns the ledger id, the ids assigned to
 * the newly staged proposals (in the same order as the request's
 * `proposals`), and the resulting full review state.
 *
 * @generated from message mono.ryugu.v1.StageDeliverableImportResponse
 */ export class StageDeliverableImportResponse extends Message {
    static fromBinary(bytes, options) {
        return new StageDeliverableImportResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StageDeliverableImportResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StageDeliverableImportResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StageDeliverableImportResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: repeated string proposal_ids = 2;
   */ _define_property(this, "proposalIds", []), /**
   * @generated from field: mono.ryugu.v1.GetDeliverableImportReviewResponse review = 3;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StageDeliverableImportResponse, "runtime", proto3);
_define_property(StageDeliverableImportResponse, "typeName", "mono.ryugu.v1.StageDeliverableImportResponse");
_define_property(StageDeliverableImportResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "review",
            kind: "message",
            T: GetDeliverableImportReviewResponse
        }
    ]));
/**
 * GetDeliverableImportReviewRequest loads server truth for a staged import.
 *
 * @generated from message mono.ryugu.v1.GetDeliverableImportReviewRequest
 */ export class GetDeliverableImportReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliverableImportReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliverableImportReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliverableImportReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliverableImportReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * Optional: restrict `proposals` to one workstream. Workstream summaries
   * are always returned for all workstreams regardless of this filter.
   *
   * @generated from field: string workstream_key = 3;
   */ _define_property(this, "workstreamKey", ""), /**
   * If false (default), SUPERSEDED proposals are omitted from `proposals`.
   *
   * @generated from field: bool include_superseded = 4;
   */ _define_property(this, "includeSuperseded", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliverableImportReviewRequest, "runtime", proto3);
_define_property(GetDeliverableImportReviewRequest, "typeName", "mono.ryugu.v1.GetDeliverableImportReviewRequest");
_define_property(GetDeliverableImportReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "include_superseded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * GetDeliverableImportReviewResponse is the review surface's source of
 * truth. The UI always renders from this response, never from a
 * DeliverableImportCard's own fields.
 *
 * @generated from message mono.ryugu.v1.GetDeliverableImportReviewResponse
 */ export class GetDeliverableImportReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliverableImportReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliverableImportReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliverableImportReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliverableImportReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string file_name = 2;
   */ _define_property(this, "fileName", ""), /**
   * @generated from field: string sheet_name = 3;
   */ _define_property(this, "sheetName", ""), /**
   * @generated from field: mono.ryugu.v1.DeliverableImportTotals totals = 4;
   */ _define_property(this, "totals", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.WorkstreamSummary workstreams = 5;
   */ _define_property(this, "workstreams", []), /**
   * @generated from field: repeated mono.ryugu.v1.DeliverableImportProposal proposals = 6;
   */ _define_property(this, "proposals", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliverableImportReviewResponse, "runtime", proto3);
_define_property(GetDeliverableImportReviewResponse, "typeName", "mono.ryugu.v1.GetDeliverableImportReviewResponse");
_define_property(GetDeliverableImportReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "totals",
            kind: "message",
            T: DeliverableImportTotals
        },
        {
            no: 5,
            name: "workstreams",
            kind: "message",
            T: WorkstreamSummary,
            repeated: true
        },
        {
            no: 6,
            name: "proposals",
            kind: "message",
            T: DeliverableImportProposal,
            repeated: true
        }
    ]));
/**
 * ResolveDeliverableImportProposalRequest records a Program Lead verdict on
 * one proposal, unedited.
 *
 * @generated from message mono.ryugu.v1.ResolveDeliverableImportProposalRequest
 */ export class ResolveDeliverableImportProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveDeliverableImportProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveDeliverableImportProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveDeliverableImportProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveDeliverableImportProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string proposal_id = 3;
   */ _define_property(this, "proposalId", ""), /**
   * @generated from field: mono.ryugu.v1.DeliverableImportVerdict verdict = 4;
   */ _define_property(this, "verdict", 0), /**
   * @generated from field: string rationale = 5;
   */ _define_property(this, "rationale", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveDeliverableImportProposalRequest, "runtime", proto3);
_define_property(ResolveDeliverableImportProposalRequest, "typeName", "mono.ryugu.v1.ResolveDeliverableImportProposalRequest");
_define_property(ResolveDeliverableImportProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "verdict",
            kind: "enum",
            T: proto3.getEnumType(DeliverableImportVerdict)
        },
        {
            no: 5,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ResolveDeliverableImportProposalResponse returns the updated proposal and
 * its workstream's refreshed summary.
 *
 * @generated from message mono.ryugu.v1.ResolveDeliverableImportProposalResponse
 */ export class ResolveDeliverableImportProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveDeliverableImportProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveDeliverableImportProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveDeliverableImportProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveDeliverableImportProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.DeliverableImportProposal proposal = 1;
   */ _define_property(this, "proposal", void 0), /**
   * @generated from field: mono.ryugu.v1.WorkstreamSummary workstream = 2;
   */ _define_property(this, "workstream", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveDeliverableImportProposalResponse, "runtime", proto3);
_define_property(ResolveDeliverableImportProposalResponse, "typeName", "mono.ryugu.v1.ResolveDeliverableImportProposalResponse");
_define_property(ResolveDeliverableImportProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal",
            kind: "message",
            T: DeliverableImportProposal
        },
        {
            no: 2,
            name: "workstream",
            kind: "message",
            T: WorkstreamSummary
        }
    ]));
/**
 * ReviseDeliverableImportProposalRequest creates a new revision that
 * supersedes an existing proposal. `revised` is the FULL set of deliverable
 * fields for the new revision, not a partial patch over the old one — the
 * caller must send every field it wants retained, not just the ones that
 * changed.
 *
 * @generated from message mono.ryugu.v1.ReviseDeliverableImportProposalRequest
 */ export class ReviseDeliverableImportProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviseDeliverableImportProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviseDeliverableImportProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviseDeliverableImportProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviseDeliverableImportProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string proposal_id = 3;
   */ _define_property(this, "proposalId", ""), /**
   * @generated from field: mono.ryugu.v1.DeliverableFields revised = 4;
   */ _define_property(this, "revised", void 0), /**
   * Optional: set to move a NEEDS_CLARIFICATION proposal to CREATE or
   * UPDATE once the Program Lead has resolved the ambiguity. Leave
   * UNSPECIFIED to keep the original action.
   *
   * @generated from field: mono.ryugu.v1.DeliverableImportAction action = 5;
   */ _define_property(this, "action", 0), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviseDeliverableImportProposalRequest, "runtime", proto3);
_define_property(ReviseDeliverableImportProposalRequest, "typeName", "mono.ryugu.v1.ReviseDeliverableImportProposalRequest");
_define_property(ReviseDeliverableImportProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "revised",
            kind: "message",
            T: DeliverableFields
        },
        {
            no: 5,
            name: "action",
            kind: "enum",
            T: proto3.getEnumType(DeliverableImportAction)
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ReviseDeliverableImportProposalResponse returns the new revision (decision
 * PENDING), the id of the proposal it superseded, and the workstream's
 * refreshed summary.
 *
 * @generated from message mono.ryugu.v1.ReviseDeliverableImportProposalResponse
 */ export class ReviseDeliverableImportProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviseDeliverableImportProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviseDeliverableImportProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviseDeliverableImportProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviseDeliverableImportProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.DeliverableImportProposal proposal = 1;
   */ _define_property(this, "proposal", void 0), /**
   * @generated from field: string superseded_proposal_id = 2;
   */ _define_property(this, "supersededProposalId", ""), /**
   * @generated from field: mono.ryugu.v1.WorkstreamSummary workstream = 3;
   */ _define_property(this, "workstream", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviseDeliverableImportProposalResponse, "runtime", proto3);
_define_property(ReviseDeliverableImportProposalResponse, "typeName", "mono.ryugu.v1.ReviseDeliverableImportProposalResponse");
_define_property(ReviseDeliverableImportProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal",
            kind: "message",
            T: DeliverableImportProposal
        },
        {
            no: 2,
            name: "superseded_proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream",
            kind: "message",
            T: WorkstreamSummary
        }
    ]));
/**
 * DeliverableCommitResult is the per-proposal outcome of a commit, including
 * the read-back verification the journey requires: after writing, the
 * server re-reads the task from storage and reports whether it matches what
 * was intended.
 *
 * @generated from message mono.ryugu.v1.DeliverableCommitResult
 */ export class DeliverableCommitResult extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableCommitResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableCommitResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableCommitResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableCommitResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_id = 1;
   */ _define_property(this, "proposalId", ""), /**
   * @generated from field: mono.ryugu.v1.DeliverableImportAction action = 2;
   */ _define_property(this, "action", 0), /**
   * @generated from field: string task_id = 3;
   */ _define_property(this, "taskId", ""), /**
   * @generated from field: mono.ryugu.v1.DeliverableCommitStatus status = 4;
   */ _define_property(this, "status", 0), /**
   * True only if the post-write read-back matched the intended fields with
   * no mismatches.
   *
   * @generated from field: bool verified = 5;
   */ _define_property(this, "verified", false), /**
   * The deliverable fields as read back from storage after the write.
   *
   * @generated from field: mono.ryugu.v1.DeliverableFields saved = 6;
   */ _define_property(this, "saved", void 0), /**
   * @generated from field: repeated string saved_occurrence_dates = 7;
   */ _define_property(this, "savedOccurrenceDates", []), /**
   * Field-level mismatches found during read-back verification, if any.
   *
   * @generated from field: repeated string mismatches = 8;
   */ _define_property(this, "mismatches", []), /**
   * @generated from field: string error = 9;
   */ _define_property(this, "error", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableCommitResult, "runtime", proto3);
_define_property(DeliverableCommitResult, "typeName", "mono.ryugu.v1.DeliverableCommitResult");
_define_property(DeliverableCommitResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "action",
            kind: "enum",
            T: proto3.getEnumType(DeliverableImportAction)
        },
        {
            no: 3,
            name: "task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "enum",
            T: proto3.getEnumType(DeliverableCommitStatus)
        },
        {
            no: 5,
            name: "verified",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "saved",
            kind: "message",
            T: DeliverableFields
        },
        {
            no: 7,
            name: "saved_occurrence_dates",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "mismatches",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CommitDeliverableImportWorkstreamRequest commits one workstream's approved
 * proposals to program tasks. Reachable only from the browser, invoked
 * directly by the human Program Lead — the agent never calls this.
 *
 * The server refuses with FailedPrecondition when the currently-approved
 * set of proposal ids for this workstream (APPROVED + EDITED_APPROVED) does
 * not exactly equal `expected_proposal_ids` — this is the guard against
 * committing against a review state that changed underneath the browser
 * tab since it last loaded GetDeliverableImportReview.
 *
 * @generated from message mono.ryugu.v1.CommitDeliverableImportWorkstreamRequest
 */ export class CommitDeliverableImportWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new CommitDeliverableImportWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitDeliverableImportWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitDeliverableImportWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitDeliverableImportWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string workstream_key = 3;
   */ _define_property(this, "workstreamKey", ""), /**
   * @generated from field: repeated string expected_proposal_ids = 4;
   */ _define_property(this, "expectedProposalIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CommitDeliverableImportWorkstreamRequest, "runtime", proto3);
_define_property(CommitDeliverableImportWorkstreamRequest, "typeName", "mono.ryugu.v1.CommitDeliverableImportWorkstreamRequest");
_define_property(CommitDeliverableImportWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_proposal_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * CommitDeliverableImportWorkstreamResponse is the commit outcome: one
 * DeliverableCommitResult per attempted proposal, the workstream's refreshed
 * summary, and aggregate counts across `results`.
 *
 * @generated from message mono.ryugu.v1.CommitDeliverableImportWorkstreamResponse
 */ export class CommitDeliverableImportWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new CommitDeliverableImportWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitDeliverableImportWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitDeliverableImportWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitDeliverableImportWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.DeliverableCommitResult results = 1;
   */ _define_property(this, "results", []), /**
   * @generated from field: mono.ryugu.v1.WorkstreamSummary workstream = 2;
   */ _define_property(this, "workstream", void 0), /**
   * @generated from field: int32 created = 3;
   */ _define_property(this, "created", 0), /**
   * @generated from field: int32 updated = 4;
   */ _define_property(this, "updated", 0), /**
   * @generated from field: int32 failed = 5;
   */ _define_property(this, "failed", 0), /**
   * @generated from field: int32 verified = 6;
   */ _define_property(this, "verified", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CommitDeliverableImportWorkstreamResponse, "runtime", proto3);
_define_property(CommitDeliverableImportWorkstreamResponse, "typeName", "mono.ryugu.v1.CommitDeliverableImportWorkstreamResponse");
_define_property(CommitDeliverableImportWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "message",
            T: DeliverableCommitResult,
            repeated: true
        },
        {
            no: 2,
            name: "workstream",
            kind: "message",
            T: WorkstreamSummary
        },
        {
            no: 3,
            name: "created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "failed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "verified",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * DeliverableImportCard is the payload shanks puts in a chat tool result for
 * thousand-sunny to render. Cards carry IDS ONLY — the UI always renders the
 * actual review content by calling GetDeliverableImportReview, never from
 * fields on the card itself; the card is a pointer plus a short message, not
 * a data payload.
 *
 * The tool result JSON wraps this, verbatim:
 *   {"success":true,"_deliverableImportCard":<protojson of this message>,"_requiresApproval":"deliverable_import_review"}
 * The `_requiresApproval` marker is present ONLY for kinds that wait on a
 * human click before the agent continues: WORKSTREAM_INTRO, PROPOSAL_REVIEW,
 * PROPOSAL_REVISED, WORKSTREAM_SUMMARY, NEXT_WORKSTREAM. It is omitted for
 * OVERVIEW, COMMIT_RESULT, PAUSED_RECAP and IMPORT_COMPLETE, which do not
 * block the agent.
 *
 * The UI reports back to the agent over chat using a single-line convention:
 *   [deliverable-import] event=<approved|rejected|deferred|revised|committed|navigate> change_set=<id> workstream=<key> proposal=<id> <free text>
 *
 * @generated from message mono.ryugu.v1.DeliverableImportCard
 */ export class DeliverableImportCard extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableImportCard().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableImportCard().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableImportCard().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableImportCard, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.DeliverableImportCardKind kind = 1;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string change_set_id = 3;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string workstream_key = 4;
   */ _define_property(this, "workstreamKey", ""), /**
   * @generated from field: string proposal_id = 5;
   */ _define_property(this, "proposalId", ""), /**
   * Set on NEXT_WORKSTREAM: the workstream the agent is about to move to.
   *
   * @generated from field: string next_workstream_key = 6;
   */ _define_property(this, "nextWorkstreamKey", ""), /**
   * @generated from field: string message = 7;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableImportCard, "runtime", proto3);
_define_property(DeliverableImportCard, "typeName", "mono.ryugu.v1.DeliverableImportCard");
_define_property(DeliverableImportCard, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(DeliverableImportCardKind)
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workstream_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "next_workstream_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
